// extracted by mini-css-extract-plugin
export default {"backButton":"List_backButton__soHF2"};